import { useState } from 'react'

import { AddNoteInput } from './add-note-input'
import { AddNoteButton } from './add-note-button'

export type Comment = string | null

type Props = {
  comment: Comment
  cartItemId: number
  inFavorites?: boolean
  disableEditing?: boolean
}

export const AddNote = ({
  comment,
  cartItemId,
  inFavorites = false,
  disableEditing = false,
}: Props) => {
  const [isOpen, setIsOpen] = useState(comment != null && comment !== '')
  const [active, setActive] = useState(false)

  return (
    <>
      <AddNoteButton
        comment={comment}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setActive={setActive}
      />

      {isOpen && (
        <AddNoteInput
          comment={comment}
          cartItemId={cartItemId}
          inFavorites={inFavorites}
          disableEditing={disableEditing}
          active={active}
          setActive={setActive}
        />
      )}
    </>
  )
}
